import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4",
    style: _normalizeStyle({ backgroundColor: _ctx.cardBg })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h6" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Configurare AD ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "my-2" }),
      _createVNode(_component_DxDataGrid, {
        ref: "dataGridRef",
        "data-source": _ctx.adSettings,
        "show-borders": true,
        "column-auto-width": true,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "remote-operations": false,
        editing: { allowUpdating: true, allowAdding: true, allowDeleting: true, mode: 'popup' },
        onRowInserting: _ctx.onRowInserting,
        onRowUpdating: _ctx.onRowUpdating,
        onRowRemoving: _ctx.onRowRemoving
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxPaging, { "page-size": 5 }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": [5,10,20],
            "show-info": ""
          }),
          _createVNode(_component_DxColumn, { "data-field": "Hostname" }),
          _createVNode(_component_DxColumn, { "data-field": "Port" }),
          _createVNode(_component_DxColumn, { "data-field": "UserName" }),
          _createVNode(_component_DxColumn, { "data-field": "PasswordCipher" }),
          _createVNode(_component_DxColumn, { "data-field": "Domain" }),
          _createVNode(_component_DxColumn, { "data-field": "SearchBase" }),
          _createVNode(_component_DxColumn, { "data-field": "ContainerName" }),
          _createVNode(_component_DxColumn, { "data-field": "DomainName" }),
          _createVNode(_component_DxColumn, { "data-field": "DomainDistinguishedName" }),
          _createVNode(_component_DxColumn, { "data-field": "SearchProperty" })
        ]),
        _: 1
      }, 8, ["data-source", "onRowInserting", "onRowUpdating", "onRowRemoving"])
    ]),
    _: 1
  }, 8, ["style"]))
}